export default __webpack_public_path__ + "images/ebf7c36309dfde1cc5d627956f9248c2-aov-hover.svg";